import { ReactNode, createContext, useContext, useEffect, useState } from 'react';
import { ServicesContext } from 'app/items/shared/context_interface';

interface CesiumCollectionContextType {
    iconCollection: Cesium.BillboardCollection | undefined;
    markerCollection: Cesium.BillboardCollection | undefined;
}

export const CesiumCollectionContext = createContext<CesiumCollectionContextType>(
    {} as CesiumCollectionContextType,
);

export const CesiumCollectionContextProvider = ({ children }: { children: ReactNode }) => {
    const { mapService } = useContext(ServicesContext);

    const [iconCollection, setIconCollection] = useState<Cesium.BillboardCollection | undefined>(
        undefined,
    );

    const [markerCollection, setMarkerCollection] = useState<
        Cesium.BillboardCollection | undefined
    >(undefined);

    useEffect(() => {
        const iconBillboards = mapService.viewer.scene.primitives.add(
            new Cesium.BillboardCollection({ scene: mapService.viewer.scene }),
        );
        setIconCollection(iconBillboards);

        const markerBillboards = mapService.viewer.scene.primitives.add(
            new Cesium.BillboardCollection({ scene: mapService.viewer.scene }),
        );
        setMarkerCollection(markerBillboards);
    }, []);

    return (
        <CesiumCollectionContext.Provider value={{ iconCollection, markerCollection }}>
            {children}
        </CesiumCollectionContext.Provider>
    );
};
